import { createContext } from 'react';

import type { IUserAuthorizationsResponse } from '@/service/vpc/types/IUserAuthorizations';

export interface UserAuthorizationsContextType {
  auths: IUserAuthorizationsResponse | null;
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export const UserAuthorizationsContext = createContext<UserAuthorizationsContextType | undefined>(undefined);
